import React from "react";
import {
  HeaderRoot,
  HeaderInner,
  Left,
  Logo,
  Nav,
  NavItem,
  Right,
  SellButton,
  IconButton,
} from "./styles";
import { Search, Heart, ShoppingBag } from "lucide-react";

export const Header: React.FC = () => {
  return (
    <HeaderRoot>
      <HeaderInner>
        {/* LEFT */}
        <Left>
          <Logo href="/">VIP RESALE</Logo>
        </Left>

        {/* CENTER */}
        {/* <Center> */}
        <Right>
          <Nav>
            <NavItem href="/vintage">ВІНТАЖ</NavItem>
            <NavItem href="/bags">СУМКИ</NavItem>
            {/* <NavItem href="/clothes">ОДЯГ</NavItem>
            <NavItem href="/shoes">ВЗУТТЯ</NavItem> */}
            <NavItem href="/accessories">АКСЕСУАРИ</NavItem>
          </Nav>

          <SellButton>ЗАМОВИТИ</SellButton>
          <IconButton aria-label="Search">
            <Search size={20} strokeWidth={1.5} />
          </IconButton>

          <IconButton aria-label="Favorites">
            <Heart size={20} strokeWidth={1.5} />
          </IconButton>

          {/* <IconButton aria-label="Profile">
            <User size={20} strokeWidth={1.5} />
          </IconButton> */}

          <IconButton aria-label="Cart">
            <ShoppingBag size={20} strokeWidth={1.5} />
          </IconButton>
        </Right>
      </HeaderInner>
    </HeaderRoot>
  );
};
